<template>
    <div class="certInit">
        <div v-if="!isSelectWrap"
             class="applyWrap">
            <div class="cryCat"></div>
            <div class="applyBox">
                <el-button type="primary"
                           size="small"
                           @click="applyBtn">{{$t('message.applyForCertification')}}
                </el-button>
                <div class="tips">
                    <p>{{$t('message.noCertification')}}</p>
                    <p>{{$t('message.pleaseClick')}}<span>{{$t('message.applyForCertification')}}</span>{{$t('message.protocolCertificating')}}
                    </p>
                </div>
            </div>
        </div>
        <div v-if="isSelectWrap"
             class="selectWrap">
            <div class="generalCat"></div>
            <div class="selectBox">
                <div class="selTit">{{$t('message.selectTypeOfCertification')}}</div>
                <div class="operatingBox">
                    <div class="importBox">
                        <div class="guideBox">
                            <div class="tit">{{$t('message.importProfession')}}</div>
                        </div>
                        <div class="certBox">
                            <div class="certBtn"
                                 :class="{active: importCert === 0}"
                                 @click="certClick('importCert', 0)">{{$t('message.monthlyUserCertification')}}
                            </div>
                            <div class="certBtn"
                                 :class="{active: importCert === 1}"
                                 @click="certClick('importCert', 1)">{{$t('message.notMonthlyUserCertification')}}
                            </div>
                        </div>
                    </div>
                    <div class="exportBox">
                        <div class="guideBox">
                            <div class="tit">{{$t('message.exportProfession')}}</div>
                        </div>
                        <div class="certBox">
                            <div class="certBtn"
                                 :class="{active: exportCert === 0}"
                                 @click="certClick('exportCert', 0)">{{$t('message.monthlyUserCertification')}}
                            </div>
                            <div class="certBtn"
                                 :class="{active: exportCert === 1}"
                                 @click="certClick('exportCert', 1)">{{$t('message.notMonthlyUserCertification')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tips">
                    <span class="asterisk">*</span>
                    <span>{{$t('message.bothProfessionCertification')}}</span>
                </div>
            </div>
            <div class="submitBtn">
                <transition name="submitBtn">
                    <el-button v-show="importCert !== -1 || exportCert !== -1"
                               size="small"
                               type="primary"
                               @click="submitBtn">{{$t('message.confirm')}}
                    </el-button>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'CertInit',
        data() {
            return {
                // 是否是 协议选择页 (false: 初始页)
                isSelectWrap: false,
                // 进口
                importCert: -1,
                // 出口
                exportCert: -1,
            };
        },
        methods: {
            // 申请认证
            applyBtn() {
                this.isSelectWrap = true;
                // 大数据 个人中心-协议认证-申请认证
                this.$bigData('certInitApply', '协议认证申请认证', '1');
            },
            // 选择业务
            certClick(data, val) {
                // 如果已选中 则重置
                // 如果没选中 则选中
                if (this[data] === val) {
                    this[data] = -1;
                } else {
                    this[data] = val;
                }
            },
            // 点击提交 
            submitBtn() {
                // 大数据 个人中心-协议认证-确定申请类型
                this.$bigData('certInitSubmitApplyType', '协议认证确定申请类型', '1');
                let inMonth = this.importCert === 0 ? '1' : '0';
                let inNotMonth = this.importCert === 1 ? '1' : '0';
                let outMonth = this.exportCert === 0 ? '1' : '0';
                let outNotMonth = this.exportCert === 1 ? '1' : '0';

                this.$router.push({
                    path: '/personalCenter/PersonalCenterMain/accountCenter/agreementCertification/CertWrite',
                    query: {
                        outMonth: outMonth,
                        outNotMonth: outNotMonth,
                        inMonth: inMonth,
                        inNotMonth: inNotMonth
                    }
                });

                // 大数据 个人中心-新增协议认证-点击提交
                this.$bigData('certInit', '新增协议认证', `inMonth: ${inMonth}, inNotMonth: ${inNotMonth}, outMonth: ${outMonth}, outNotMonth: ${outNotMonth}`);
            }
        },
    };
</script>
<style scoped>

    .submitBtn-enter-active,
    .submitBtn-leave-active {
        transition: opacity 0.6s;
    }

    .submitBtn-enter,
    .submitBtn-leave-to {
        opacity: 0;
    }

    *:link,
    *:visited,
    *:hover,
    *:active,
    *:focus {
        transition: color 0.25s linear, background-color 0.25s linear, border-color 0.25s linear;
    }

    .icon {
        width: 1em;
        height: 1em;
        overflow: hidden;
        vertical-align: -0.15em;
        fill: currentColor;
    }

    .certInit {
        position: relative;
        width: 1070px;
        height: 655px;
        overflow: hidden;
    }

    .applyWrap,
    .selectWrap {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .applyWrap .cryCat {
        position: absolute;
        top: 165px;
        left: 233px;
        width: 208px;
        height: 276px;
        background-image: url("~@/assets/img/personalCenter/accountCenter/agreementCertification/certInit/cry_cat.png");
    }

    .applyWrap .applyBox {
        position: absolute;
        top: 260px;
        left: 384px;
        width: 400px;
        text-align: center;
    }

    .applyBox .tips {
        position: relative;
        width: 100%;
        margin-top: 36px;
    }

    .applyBox .tips p {
        position: relative;
        font-size: 18px;
        color: #717071;
        text-align: center;
    }

    .applyBox .tips p + .applyBox .tips p {
        margin-top: 5px;
    }

    .applyBox .tips p span {
        color: #0094dd;
    }

    @keyframes selectBoxRotate {
        0% {
            transform: rotateX(40deg) translateZ(100px) translateY(120px);
        }

        100% {
            transform: rotateX(0deg) translateZ(0) translateY(0);
        }
    }

    .selectWrap {
        perspective: 800px;
    }

    .selectWrap .generalCat {
        position: absolute;
        top: 65px;
        left: 50%;
        width: 179px;
        height: 238px;
        margin-left: -90px;
        background-image: url("~@/assets/img/personalCenter/accountCenter/agreementCertification/certInit/general_cat.png");
    }

    .selectWrap .selectBox {
        position: relative;
        width: 575px;
        height: 270px;
        margin: 192px auto 0;
        background-color: white;
        border: 1px solid #a7a7a7;
        border-radius: 16px;
        animation: selectBoxRotate 1s forwards;
    }

    .selectBox .selTit {
        position: relative;
        margin-top: 46px;
        font-size: 18px;
        color: #0094dd;
        text-align: center;
    }

    .selectBox .operatingBox {
        position: relative;
        width: 100%;
        margin-top: 30px;
        overflow: hidden;
    }

    .selectBox .operatingBox .importBox,
    .selectBox .operatingBox .exportBox {
        position: relative;
        float: left;
        text-align: center;
    }

    .selectBox .operatingBox .importBox {
        width: 50%;
    }

    .selectBox .operatingBox .exportBox {
        width: calc(50% - 2px);
        border-left: 1px dashed #717071;
    }

    .selectBox .operatingBox > div .guideBox {
        position: relative;
        display: inline-block;
        width: 141px;
        height: 30px;
        margin-top: 26px;
        text-align: center;
        border: 1px solid #717071;
        border-bottom: none;
    }

    .selectBox .operatingBox > div .guideBox .tit {
        position: relative;
        top: -14px;
        display: inline-block;
        padding: 0 6px;
        font-size: 18px;
        color: #0094dd;
        text-align: center;
        background-color: white;
    }

    .selectBox .operatingBox > div .certBox {
        position: relative;
        width: 100%;
        height: 30px;
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 16px;
        color: white;
    }

    .selectBox .operatingBox > div .certBox .certBtn {
        position: relative;
        display: inline-block;
        width: 120px;
        height: 30px;
        margin: 0 6px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        background-color: #a5a5a5;
    }

    .selectBox .operatingBox > div .certBox .certBtn.active {
        background-color: #0094dd;
    }

    .selectBox .operatingBox > div .certBox .certBtn:hover {
        background-color: #0094dd;
    }

    .selectBox .tips {
        position: relative;
        margin-top: 35px;
        color: #9e9e9f;
        text-align: center;
    }

    .selectBox .tips .asterisk {
        color: red;
    }

    .submitBtn {
        margin-top: 30px;
        text-align: center;
    }
</style>